exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style__InformationFormsContainer___3h88W {\n  margin-top: 40px; }\n\n.style__InformationFormsWrapper___11Db4 p {\n  margin-right: auto;\n  font-family: Roboto;\n  font-size: 18px;\n  font-weight: normal;\n  font-style: normal;\n  text-align: left;\n  color: #333333; }\n\n.style__FormStyle___2nPzC {\n  padding: 15px 20px 15px 20px;\n  font-family: Roboto; }\n", ""]);

// exports
exports.locals = {
	"InformationFormsContainer": "style__InformationFormsContainer___3h88W",
	"InformationFormsWrapper": "style__InformationFormsWrapper___11Db4",
	"FormStyle": "style__FormStyle___2nPzC"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/component/Forms/AreaInput/style.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/component/Forms/AreaInput/style.css
// module chunks = 0